import { FC } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom-v5-compat';
import { Dispatch, bindActionCreators } from 'redux';
import { OPEN_PASSWORDS } from 'src/api';
import axios from 'src/axios';
import {
  handleErrorToast,
  handleSuccessToast,
  handleWarningToast,
} from 'src/components/molecules';
import * as OpenReportingCreators from '../../../creators/OpenReporting.creators';
import * as Types from '../../../types';
import Password from './Password';

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

interface OwnProps {
  currentUser?: Types.User;
  organisation?: string;
}

const ChangePassword: FC<Props> = ({
  currentUser,
  organisation,
  changePasswordValues,
  onChangePassword,
}) => {
  const navigate = useNavigate();

  const changePassword = async () => {
    try {
      await axios.put(OPEN_PASSWORDS, {
        current: changePasswordValues?.currentPassword,
        password: changePasswordValues?.newPassword,
        confirmation: changePasswordValues?.confirmNewPassword,
      });
      handleSuccessToast({ toastMessage: 'Password changed successfully' });
      onChangePassword();
      navigate(`/${organisation}/open-reporting/reports`);
    } catch (error) {
      const err = (
        error as {
          response: { data: { errors: { message: string }[] } };
        }
      )?.response?.data?.errors[0]?.message;
      if (err === 'Password has been used before') {
        handleWarningToast({
          toastMessage: 'Password reuse not allowed',
          toastDescription:
            "For your safety, you can't reuse any of your last six passwords. Please choose a new, unique password to keep your account secure and try again.",
        });
      } else {
        handleErrorToast({
          toastMessage: err ?? 'Password change failed',
        });
      }
    }
  };
  return (
    <Password
      submit={changePassword}
      changePassword={true}
      currentUser={currentUser}
      isLocalised={true}
    />
  );
};

const mapStateToProps = (state: Types.State, ownProps: OwnProps) => ({
  changePasswordValues: state.openReporting.changePasswordReducer,
  ...ownProps,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      ...OpenReportingCreators,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
